import { IApiStream, IApiNewStream, IApiStreamBase, IApiServerBase } from '@cbridge-packages/api';
import { ClientTranslator } from '@cbridge-packages/client';
import { MarkupProfileTranslator } from '@cbridge-packages/markup-profile';
import { INode } from '@cbridge-packages/node';
import { ServerTranslator } from '@cbridge-packages/server';
import { IStream, IStreamForm, IStreamBase, IStreamServer } from './stream.interface';

export namespace StreamTranslator {
  export function fromApiBase(stream: IApiStreamBase): IStreamBase {
    return {
      streamId: stream.id,
      name: stream.name,
    };
  }

  export function fromApi(stream: IApiStream): IStream {
    return {
      streamId: stream.id,
      markupProfile: MarkupProfileTranslator.fromApi(stream.markupProfile),
      name: stream.name,
      clients: stream.clients?.map(ClientTranslator.fromApi),
      clientSymbolsCount: stream.clientSymbolsCount,
      servers: stream.servers?.map(StreamTranslator.fromApiStreamServer),
    };
  }

  export function fromApiStreamServer(server: IApiServerBase): IStreamServer {
    return {
      serverId: server.id,
      name: server.name,
      type: ServerTranslator.fromApiServerType(server.type),
      tradingClient: server?.tradingClient && {
        clientId: server.tradingClient.id,
        enabled: server.tradingClient.enabled,
      },
      throttlingInterval: server.throttlingInterval,
    };
  }

  export function toFormData(stream: IStream, nodeId: INode['nodeId']): IStreamForm {
    if (stream) {
      return {
        streamId: stream.streamId,
        name: stream.name,
        nodeId,
        markupProfileId: stream.markupProfile?.markupProfileId,
      };
    }

    return {
      nodeId,
      name: '',
    };
  }

  export function toApi(stream: IStreamForm): IApiNewStream {
    return {
      name: stream.name,
      markupProfileId: stream.markupProfileId,
    };
  }
}
